(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["limited-time-sale-collections"] && !Shopify.designMode) return;
  try {
    
  function sortTomoSaleCollections(section) {
    const grid = section.querySelector('.limited-time-sale-collections__grid');

    if (!grid) return;

    Array.from(grid.querySelectorAll('[data-tomo-sale-card]'))
      .sort((cardA, cardB) => {
        const endsAtA = Number(cardA.dataset.saleEndsAtTimestamp) || 0;
        const endsAtB = Number(cardB.dataset.saleEndsAtTimestamp) || 0;
        const sortOrder = section.dataset.tomoSaleSortOrder || 'ending_latest';

        if (sortOrder === 'ending_soon') {
          return endsAtA - endsAtB;
        }

        return endsAtB - endsAtA;
      })
      .forEach((card) => grid.appendChild(card));
  }

  function updateTomoSaleCarouselControls(section) {
    const carousel = section.querySelector('[data-tomo-sale-carousel]');
    const controls = section.querySelector('.limited-time-sale-collections__controls');
    const previousButton = section.querySelector('[data-tomo-sale-carousel-prev]');
    const nextButton = section.querySelector('[data-tomo-sale-carousel-next]');

    if (!carousel || !controls || !previousButton || !nextButton) return;

    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    const hasOverflow = maxScroll > 2;

    controls.hidden = !hasOverflow;
    previousButton.disabled = carousel.scrollLeft <= 2;
    nextButton.disabled = carousel.scrollLeft >= maxScroll - 2;
  }

  function tickTomoSaleCountdown(countdown) {
    if (typeof countdown.tick !== 'function') return false;

    const tickResult = countdown.tick();

    return tickResult !== false && countdown.isConnected && !countdown.hidden;
  }

  function restartTomoSaleCountdowns(section) {
    window.tomoSaleCountdownIntervals = window.tomoSaleCountdownIntervals || new WeakMap();

    section.querySelectorAll('tomo-sale-countdown').forEach((countdown) => {
      if (window.tomoSaleCountdownIntervals.has(countdown)) return;
      if (!tickTomoSaleCountdown(countdown)) return;

      const interval = window.setInterval(() => {
        if (tickTomoSaleCountdown(countdown)) return;

        window.clearInterval(interval);
        window.tomoSaleCountdownIntervals.delete(countdown);
      }, 1000);

      window.tomoSaleCountdownIntervals.set(countdown, interval);
    });
  }

  function scrollTomoSaleCarousel(section, direction) {
    const carousel = section.querySelector('[data-tomo-sale-carousel]');

    if (!carousel) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    carousel.scrollBy({
      left: carousel.clientWidth * direction * 0.9,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }

  function initializeTomoSaleCollection(section) {
    sortTomoSaleCollections(section);
    restartTomoSaleCountdowns(section);
    updateTomoSaleCarouselControls(section);

    if (section.dataset.tomoSaleCarouselInitialized === 'true') return;

    section.dataset.tomoSaleCarouselInitialized = 'true';

    const carousel = section.querySelector('[data-tomo-sale-carousel]');
    const previousButton = section.querySelector('[data-tomo-sale-carousel-prev]');
    const nextButton = section.querySelector('[data-tomo-sale-carousel-next]');

    previousButton?.addEventListener('click', () => scrollTomoSaleCarousel(section, -1));
    nextButton?.addEventListener('click', () => scrollTomoSaleCarousel(section, 1));
    carousel?.addEventListener('scroll', () => updateTomoSaleCarouselControls(section), { passive: true });
    window.addEventListener('resize', () => updateTomoSaleCarouselControls(section));
  }

  function sortAllTomoSaleCollections() {
    document.querySelectorAll('[data-tomo-sale-section]').forEach(initializeTomoSaleCollection);
  }

  sortAllTomoSaleCollections();
  document.addEventListener('DOMContentLoaded', sortAllTomoSaleCollections);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-tomo-sale-section]').forEach(initializeTomoSaleCollection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tomo-homepage-live-sales"] && !Shopify.designMode) return;
  try {
    
  function sortTomoLiveSalesEndingSoon() {
    document.querySelectorAll('[data-tomo-live-sales-grid]').forEach((grid) => {
      Array.from(grid.querySelectorAll('.tomo-live-sales__card'))
        .sort((cardA, cardB) => {
          const endsAtA = Number(cardA.dataset.saleEndsAtTimestamp) || 0;
          const endsAtB = Number(cardB.dataset.saleEndsAtTimestamp) || 0;

          return endsAtA - endsAtB;
        })
        .forEach((card) => grid.appendChild(card));
    });
  }

  sortTomoLiveSalesEndingSoon();
  document.addEventListener('DOMContentLoaded', sortTomoLiveSalesEndingSoon);
  document.addEventListener('shopify:section:load', sortTomoLiveSalesEndingSoon);

  } catch(e) { console.error(e); }
})();
})();
